import { get } from 'lodash'
import * as React from 'react'

import { CreditCardSubtypes } from 'embed/constants'

const styles = require('./styles.scss')

const SecuredCard = require('./secured-card.svg')

export interface Props {
  subtype?: CreditCardSubtypes
}

export const CreditCardSubtypeData = {
  [CreditCardSubtypes.SecuredCard]: {
    details: 'Secured cards require you to deposit cash ahead of time to cover your line of credit',
    image: <SecuredCard />,
    title: 'Secured Card',
  },
}

const SpecialSubtypeNotice = ({ subtype }) => {
  if (get(CreditCardSubtypeData, subtype) !== undefined) {
    const subtypeData = CreditCardSubtypeData[subtype]

    return (
      <div className={styles.specialSubtype}>
        {subtypeData.image} {subtypeData.title}
      </div>
    )
  } else {
    return null
  }
}

export default SpecialSubtypeNotice
